export default __webpack_public_path__ + "static/0011-d56524e386a9d0bf9e5490c1401bab38.png";